import { useNavigate } from "react-router-dom";
import Garden1 from "../../Images/Garden1.jpeg";
import Garden2 from "../../Images/Garden2.webp";
import Garden3 from "../../Images/Garden3.webp";
import Garden4 from "../../Images/Garden4.jpeg";
import Garden5 from "../../Images/Garden5.jpg";
import Garden6 from "../../Images/GarvanaHome8.png"; // ⭐ Add image import
import Garden7 from "../../Images/GarvanaHome9.png"; // ⭐ Add image import
import Garden8 from "../../Images/GarvanaHome10.png"; // ⭐ Add image import
import "./AboutUs.css";

export default function AboutUs({ contactRef }) {
  const handleContactClick = () => {
    navigate("/");
  };
  const navigate = useNavigate();
  const whyChooseUsPoints = [
    { icon: "✅", text: "Landscape Design & Garden Management by Experts" },
    { icon: "✅", text: "5+ Years of Horticulture & Landscaping Experience" },
    { icon: "✅", text: "Premium Quality Nursery Plants" },
    { icon: "✅", text: "Eco-Friendly, Organic Garden Solutions" },
    { icon: "✅", text: "Customized Outdoor Space Planning" },
    { icon: "✅", text: "Affordable & Transparent Pricing" },
    { icon: "✅", text: "One-Stop Solution for Homes & Businesses" },
    { icon: "✅", text: "On-Time Project Delivery & Maintenance" },
    { icon: "✅", text: "Serving Delhi NCR, Noida, Gurugram, Faridabad, Ghaziabad" },
    { icon: "✅", text: "Trusted by Hotels, Villas & Architects" }
  ];

  return (
    <div className="about-wrapper">

      {/* ⭐ TOP CENTERED HEADING */}
      <h1 className="about-main-heading">🌿 About Us</h1>
      <div className="about-container">
        
        <div className="about-content">

          {/* Left image column */}
          <div className="about-image-column">
            <img src={Garden6} alt="Garden 1" />
            <img src={Garden8} alt="Garden 2" />
            <img src={Garden5} alt="Garden 5" />
            <img src={Garden7} alt="Garden 7" />
            <img src={Garden1} alt="Garden 3" />
            <img src={Garden3} alt="Garden 4" />
            <img src={Garden4} alt="Garden 6" />
          </div>

          {/* Right text section */}
          <div className="about-text">
            <h2 className="about-title">Creating Green Spaces, Enriching Lives</h2>

            <p className="about-description">
              Welcome to Garana Enterprise, a trusted name in nursery,
              landscape design, and garden services. With over 5 years 
              of experience, we transform outdoor & indoor spaces into 
              lush, eco-friendly environments.
            </p>

            <h3 className="about-subtitle">🌱 Who We Are</h3>
            <p>
              We combine creativity with nature to deliver premium landscaping 
              solutions for homes, offices, villas, resorts, farmhouses, and 
              commercial properties.
            </p>
            <p>
              Our team has delivered highly successful projects across Delhi NCR 
              including Noida, Gurugram, Ghaziabad, and Faridabad.
            </p>

            <h3 className="about-subtitle">🌿 What We Offer</h3>
            <div className="about-services">
              <div className="service-box">🌿 Landscape Design & Garden Management</div>
              <div className="service-box">📐 3D Garden Visualization</div>
              <div className="service-box">🏡 Custom Garden Planning (Villas & Homes)</div>
              <div className="service-box">🪴 Indoor Plant Décor & Maintenance</div>
              <div className="service-box">🌱 Organic Terrace Gardening</div>
              <div className="service-box">💧 Drip & Sprinkler Irrigation</div>
              <div className="service-box">🌼 Lawn Creation & Grass Carpeting</div>
              <div className="service-box">🌻 Flower Bed Designing</div>
              <div className="service-box">🎍 Vertical Green Walls</div>
              <div className="service-box">🌳 Tree Plantation & Care</div>
            </div>
          </div>
        </div>
      </div>

      {/* WHY CHOOSE US SECTION */}
      <div className="why-section">
        <div className="why-content">
          <h2 className="why-title">🌿 Why Choose Garvana?</h2>
          <p className="why-subtitle">
            Delivering high-quality, nature-rich spaces across Delhi NCR.
          </p>

          <div className="why-grid">
            {whyChooseUsPoints.map((item, index) => (
              <div className="why-item" key={index}>
                <span className="check-icon">{item.icon}</span>
                <p><strong>{item.text}</strong></p>
              </div>
            ))}
          </div>

          <div className="why-cta">
            <p>Let’s bring your dream garden to life. 🌱</p>
            <button className="why-btn" onClick={handleContactClick}>
              Get Started
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
